<template>
  <div class="contai">
    <h2>{{ text }}</h2>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "notice",

  data() {
    return {
      appid: "wx9019ccce538953c5",
      secret: "6a8c6a6091b33b7bd9213e166106a3fb",
      Access_token: "Access_token", //公众号的Access_token
      openid: "", //公众号的用户的openid
      SCENE: "",
      // loading: true,
      TOKEN: "", //小程序的Access_token
      code: "", //公众号code
      token: "", //公众号的发模板消息token
      deta: "", //今天的日期
      unionid: "", //unionid
      nickname: "", //当户的微信昵称
      // https://api.weixin.qq.com/sns/oauth2/access_token?appid=${appid}&secret=${secret}&code=${code}&grant_type=authorization_code
      text: "同步完成",
    };
  },
  methods: {
    //获取用户信息和token
    getData() {
      this.axios
        .get("/api/sns/oauth2/access_token", {
          params: {
            appid: this.appid,
            secret: this.secret,
            code: this.code,
            grant_type: "authorization_code",
          },
        })
        .then((res) => {
          this.Access_token = res.data.access_token;
          this.openid = res.data.openid;
          // this.token = res.data.access_token;
          this.getUser(res.data.access_token);
        });
    },

    // send() {
    //   this.axios
    //     .post("/api/cgi-bin/message/template/send?access_token=" + this.token, {
    //       touser: this.openid,
    //       template_id: "Bwl0fqkB8eS2xKEFCDVNl3kSnrYISA3_fviw4_uUGoE",
    //       // url: "http://weixin.qq.com/download",
    //       //  "miniprogram":{
    //       appid: "wx153c354afba9df6f",
    //       //    "pagepath":"index?foo=bar"
    //       //  },
    //       data: {
    //         first: {
    //           value: "微信订阅成功",
    //           color: "#173177",
    //         },
    //         name: {
    //           value: this.nickname,
    //           color: "#173177",
    //         },
    //         time: {
    //           value: this.deta,
    //           color: "#173177",
    //         },
    //         remark: {
    //           value:
    //             "尊敬的当户你好：\n微信推送订阅成功后，在我行办理的典当业务将采用微信自动推送服务，建当、到期、逾期、绝当、续当都会有微信自动提醒",
    //           color: "#173177",
    //         },
    //       },
    //     })
    //     .then(() => {
    //       this.addData();
    //     });
    // },

    //获取公众号Access_token，发模板消息用的token
    // getTonek() {
    //   this.axios
    //     .get("/api/cgi-bin/token", {
    //       params: {
    //         grant_type: "client_credential",
    //         appid: "wx9019ccce538953c5",
    //         secret: "6a8c6a6091b33b7bd9213e166106a3fb",
    //       },
    //     })
    //     .then((re) => {
    //       this.token = re.data.access_token;
    //     });
    // },

    //获取用户信息
    getUser(e) {
      this.axios
        .get("/api/sns/userinfo", {
          params: {
            access_token: e,
            openid: this.openid,
            lang: "zh_CN",
          },
        })
        .then((userinfo) => {
          this.unionid = userinfo.data.unionid;
          // this.nickname = userinfo.data.nickname;
          this.addData();
        });
    },

    //获取小程序Access_token
    getAcctoken() {
      this.axios
        .get("/api/cgi-bin/token?grant_type=client_credential", {
          params: {
            appid: "wx153c354afba9df6f",
            secret: "82eda09f80ff4b7b90865c533ffe47ab",
          },
        })
        .then((tokens) => {
          // console.log(tokens);
          this.TOKEN = tokens.data.access_token;
        });
    },

    //把openid添加到云开发数据库
    addData() {
      //查找一下数据库里的有没有添加过该数据

      this.axios
        .post("/api/tcb/databaseadd?access_token=" + this.TOKEN, {
          env: "changan2020-qtz0s",
          query: `db.collection("openids").add({data:{openid:"${this.openid}",unionid:"${this.unionid}"}})`,
        })
        .then((rcode) => {
          if (rcode.data.errcode == 0) {
            this.text = "同步完成，请关闭页面";
          }
        });
    },
  },
  created() {
    this.deta = dayjs().format("YYYY-MM-DD");
    this.code = this.$route.query.code;
    this.getAcctoken(); //获取小程序Access_token
    this.getTonek(); //获取公众号Access_token
  },
  mounted() {
    // this.sens();
    this.getData();

    // setTimeout(() => {
    //   this.send();
    // }, 1000);
  },
};
</script>
<style scoped>
.contai {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>
